module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_stores-3be2b166708f26a9111bf06d03342db8.webp";